export default {
  supportVisible: {
    zIndex: 9999,
    position: "fixed",
    right: "24px",
    bottom: "90px",
    transition: "400ms"
  },
  supportHidden: {
    zIndex: 9999,
    position: "fixed",
    right: "24px",
    bottom: "20px",
    transition: "400ms"
  },
  subFab: {
    right: "30px",
    zIndex: 1,
    position: "fixed",
    transition: "400ms"
  },
  subFabHidden: {
    opacity: "0",
    visibility: "hidden"
  },
  subFabVisible: {
    opacity: "1"
  },
  mainIcon: {
    paddingTop: "9px",
    paddingLeft: "2px"
  },
  subIcon: {
    top: "5px",
    position: "relative"
  }
};



// WEBPACK FOOTER //
// ./src/components/support/fab/style.js